import {useUserStore} from '@/stores/user';

export function fpost(path, body = {}, headers = {}) {
    const userStore = useUserStore();

    return fetch(import.meta.env.VITE_API_BASE_URL + path, {
        method: 'POST',
        headers: Object.assign({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userStore.api_token}`
        }, headers),
        body: JSON.stringify(body),
    })
}

export function fpatch(path, body = {}, headers = {}) {
    const userStore = useUserStore();

    return fetch(import.meta.env.VITE_API_BASE_URL + path, {
        method: 'PATCH',
        headers: Object.assign({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userStore.api_token}`
        }, headers),
        body: JSON.stringify(body),
    });
}

/**
 * Call `path` without Authorization
 *
 * @param path
 * @param body
 * @param headers
 */
export function fpost_anonymous(path, body = {}, headers = {}) {
    return fetch(import.meta.env.VITE_API_BASE_URL + path, {
        method: 'POST',
        headers: Object.assign({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }, headers),
        body: JSON.stringify(body),
    });
}

export function fget(path) {
    const userStore = useUserStore();

    return fetch(`${import.meta.env.VITE_API_BASE_URL}${path}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userStore.api_token}`
        },
    });
}

export function fdelete(path, body = {}, headers = {}) {
    const userStore = useUserStore();

    return fetch(import.meta.env.VITE_API_BASE_URL + path, {
        method: 'DELETE',
        headers: Object.assign({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userStore.api_token}`
        }, headers),
        body: JSON.stringify(body),
    })
}

export function fput(path, body = {}, headers = {}) {
    const userStore = useUserStore();

    return fetch(import.meta.env.VITE_API_BASE_URL + path, {
        method: 'PUT',
        headers: Object.assign({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userStore.api_token}`
        }, headers),
        body: JSON.stringify(body),
    })
}